import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../shared/services/navigation.service';
declare var $: any;
@Component({
  selector: 'app-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit {
  public patients:any;
  public pharmacy:any;
  textColor: string = "";
  showFiller = false;
LayoutComponent = LayoutComponent;
constructor(private navigate:NavigationService){
  }
ngOnInit() {
  }
back(){
    this.navigate.back();
  }
}
